var map = {
	"./cover.jpg": 15,
	"./elina_hoch.jpg": 53,
	"./elina_quad.jpg": 16,
	"./elina_quer.jpg": 54,
	"./farije_hoch.jpg": 55,
	"./farije_quad.jpg": 17,
	"./farije_quer.jpg": 56,
	"./hazeta_hoch.jpg": 57,
	"./hazeta_quad.jpg": 18,
	"./hazeta_quer.jpg": 58,
	"./margarida_hoch.jpg": 59,
	"./margarida_quad.jpg": 19,
	"./margarida_quer.jpg": 60,
	"./readme.md": 64
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52;